import type { ChangeWorkGroup } from '../../types/changes';

export type WorkGroupListLabels = {
  checklist: (item: ChangeWorkGroup) => string;
  incident: (item: ChangeWorkGroup, queueName?: string) => string;
  peopleNames: (item: ChangeWorkGroup) => string;
};

export function filterWorkGroupsBySearch(
  items: ChangeWorkGroup[],
  query: string,
  queueNameById: Record<number, string>,
  labels: WorkGroupListLabels,
): ChangeWorkGroup[] {
  const needle = query.trim().toLocaleLowerCase('pt-BR');
  if (!needle) return items;
  return items.filter((item) => {
    const queueName = item.incidents_group_id
      ? queueNameById[item.incidents_group_id]
      : undefined;
    const blob = [
      item.name,
      item.description,
      labels.checklist(item),
      labels.incident(item, queueName),
      labels.peopleNames(item),
      item.is_active ? 'ativo' : 'inativo',
    ]
      .filter(Boolean)
      .join(' ')
      .toLocaleLowerCase('pt-BR');
    return blob.includes(needle);
  });
}
